<div class="dropdown-container {{CompatibilityService.LegacyCustomClass('legacy-dropdown-container')}}"
     *ngIf="IsDropDownOpen"
     [style.top.px]="ContainerTop"
     [style.width.px]="ContainerWidth">
    <div class="dropdown-control" 
         [style.max-width]="MaxWidth" 
         [style.min-width]="MinWidth"
         [style.width]="Width" 
         [style.right]="HorizontalAlignment == 'Right' ? 0 : auto">
        <ng-content></ng-content>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/base/drop-down/drop-down.html